import { Link } from 'react-router-dom';
import { AdministrationLayout } from '@/shared/layouts/AdministrationLayout';
import { useActiveModule } from '@/hooks/useActiveModule';
import { moduleAdminPath } from '@/config/moduleDefaults';
import type { ErpModule } from '@/api/platform.api';

function adminLinks(module: ErpModule) {
  return [
    {
      to: moduleAdminPath(module, 'profile'),
      label: 'Organization',
      description: 'Profile, branding, and company details',
    },
    {
      to: moduleAdminPath(module, 'users'),
      label: 'Users',
      description: 'Manage employees and access',
    },
    {
      to: moduleAdminPath(module, 'roles'),
      label: 'Roles',
      description: 'Permissions and role templates',
    },
    {
      to: moduleAdminPath(module, 'subscription'),
      label: 'Subscription',
      description: 'Plans, billing, and module usage',
    },
    {
      to: moduleAdminPath(module, 'settings'),
      label: 'Module settings',
      description: 'Password, theme, and feature preferences',
    },
  ];
}

export function AdministrationPage() {
  const activeModule = useActiveModule();
  const links = activeModule ? adminLinks(activeModule) : [];

  return (
    <AdministrationLayout
      title="Administration"
      description="Organization controls for this module workspace."
    >
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {links.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="rounded-xl border border-slate-200/80 bg-white p-4 shadow-sm transition hover:border-primary-300 dark:border-slate-800 dark:bg-slate-900 dark:hover:border-primary-700"
          >
            <p className="font-semibold text-slate-900 dark:text-slate-100">{item.label}</p>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">{item.description}</p>
          </Link>
        ))}
      </div>
    </AdministrationLayout>
  );
}
